import React, { useState } from 'react';
import { Modal } from '@mui/material';
import { WelcomeModal } from '../../../../assets/images';
import ReferralModal from './referral-modal.component';
import styles from './welcome.module.scss';
import { GiftInvitePreview } from '../../../lifetime-credits/gift-invite-welcome';

type LandingReferrer = {
  _id?: string;
  channelName?: string;
};

type LandingReferrerWelcomeProps = {
  isLoadingReferrer: boolean;
  referredBy?: LandingReferrer;
  getReferrerUser: (channelId?: string, startTimer?: boolean) => void;
  giftInvite?: GiftInvitePreview | null;
};

export function shouldShowLandingReferralWelcome(
  isLoadingReferrer: boolean,
  referredBy?: Pick<LandingReferrer, '_id'> | null,
): boolean {
  return !isLoadingReferrer && Boolean(referredBy?._id);
}

export function LandingReferrerWelcome({
  isLoadingReferrer,
  referredBy,
  getReferrerUser,
  giftInvite = null,
}: LandingReferrerWelcomeProps): JSX.Element | null {
  const [genericOpen, setGenericOpen] = useState(true);
  const [referralDismissed, setReferralDismissed] = useState(false);

  if (isLoadingReferrer || referralDismissed) {
    return null;
  }

  if (shouldShowLandingReferralWelcome(isLoadingReferrer, referredBy)) {
    return (
      <ReferralModal
        referredBy={referredBy}
        giftInvite={giftInvite}
        onClose={() => setReferralDismissed(true)}
        getReferrerUser={(channelId?: string, startNow?: boolean) => {
          getReferrerUser(channelId, startNow);
        }}
      />
    );
  }

  if (!genericOpen) {
    return null;
  }

  return (
    <Modal
      open={genericOpen}
      onClose={() => setGenericOpen(false)}
      aria-labelledby="landing-welcome-title"
      aria-describedby="landing-welcome-description"
    >
      <div
        role="presentation"
        onClick={() => setGenericOpen(false)}
      >
        <img
          className={styles.modalImage}
          src={WelcomeModal}
          alt="Welcome to QuickCam"
        />
      </div>
    </Modal>
  );
}

LandingReferrerWelcome.defaultProps = {
  referredBy: undefined,
  giftInvite: null,
};

export default LandingReferrerWelcome;
